import React from "react";
import "./Home.css";

const Home = () => {
  return (
    <div className="landingContainer">
      <div className="Context">
        <h2>A society to transform you as a coder!</h2>
        <span className="LandingContent">
          <span>Code.</span>
          <span>Debug.</span>
          <span>Compete</span>
        </span>
      </div>
    </div>
  );
};

export default Home;
